import React, { useEffect, useState } from 'react';
import { Switch, Divider } from '@chakra-ui/react';
import { updateSettings, fetchListSettings } from '../../../apis/notification.api';

function NotificationSettings() {
  const [listSettings, setListSettings] = useState([]);
  const [triggerFetchSettings, setFetchSettings] = useState(false);
  const [pauseSetting, setPauseSetting] = useState(false);

  const getNotificationSettingOnKey = (key) => {
    return listSettings.find((setting) => setting.name === key);
  };

  const handleChangeSetting = async (typeId, option) => {
    switch (typeId) {
      case 0: {
        await Promise.all(
          listSettings.map(async (setting) => {
            await updateSettings({ typeId: setting.id, option });
          })
        );
        setListSettings((pre) => pre.map((item) => ({ ...item, option })));
        setPauseSetting(!option);
        break;
      }
      default: {
        try {
          await updateSettings({ typeId, option: !option });
          setListSettings((pre) =>
            pre.map((item) => (item.id === typeId ? { ...item, option: !option } : item))
          );
        } catch (e) {}
      }
    }
    setFetchSettings(!triggerFetchSettings);
  };

  const OptionComponent = (key) => {
    const option = getNotificationSettingOnKey(key);
    if (!option) return <></>;

    return (
      <div className="flex items-center gap-2">
        <div>
          <p className="font-[600]">{option.name}</p>
          <p className="text-dim-gray">{option.description}</p>
        </div>
        <Switch
          onChange={() => handleChangeSetting(option.id, option.option)}
          isChecked={option.option}
          className="ml-auto"
          sx={{
            '--switch-track-width': '40px',
            '--switch-track-height': '20px',
            '--switch-thumb-size': '20px'
          }}
          variant="light-green"
        />
      </div>
    );
  };

  useEffect(() => {
    const fetchListSetting = async () => {
      try {
        const data = await fetchListSettings();
        if (data) {
          setListSettings(data);
          setFetchSettings(!triggerFetchSettings);
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };
    fetchListSetting();
  }, []);

  useEffect(() => {
    setPauseSetting(listSettings.every((setting) => setting.option === false));
  }, [triggerFetchSettings]);

  return (
    <div className="w-full mt-6">
      {/* Ignored all */}
      <div className="overflow-y-auto">
        <div className="flex items-center mb-5">
          <div>
            <p className="font-[600]">Pause All notifications</p>
            <p className="text-02-dim-gray">Control all notifications in general</p>
          </div>
          <Switch
            onChange={() => handleChangeSetting(0, pauseSetting)}
            isChecked={pauseSetting}
            className="ml-auto"
            variant="light-green"
            sx={{
              '--switch-track-width': '40px',
              '--switch-track-height': '20px',
              '--switch-thumb-size': '20px'
            }}
          />
        </div>
      </div>
      <Divider />

      {/* My Articles */}
      <div className="py-5">
        <div>
          <h3 className="font-[600] text-earth-brown-500 mb-4">My Articles:</h3>
        </div>
        <div className="flex flex-col gap-6">
          {OptionComponent('Article Comments')}
          {OptionComponent('Article Reactions')}
          {OptionComponent('Comments on Article sections')}
        </div>
      </div>
      <Divider />

      {/* Comments */}
      <div className="py-5">
        <div>
          <h3 className="font-[600] text-earth-brown-500 mb-4">Comments:</h3>
        </div>
        <div className="flex flex-col gap-6">
          {OptionComponent('Comment Likes')}
          {OptionComponent('Replies to my comments')}
        </div>
      </div>
      <Divider />

      {/* Followers */}
      <div className="py-5">
        <div>
          <h3 className="font-[600] text-earth-brown-500 mb-4">Followers:</h3>
        </div>

        {OptionComponent('New Followers')}
      </div>
      <Divider />

      {/* Requests and responses */}
      <div className="py-5">
        <div>
          <h3 className="font-[600] text-earth-brown-500 mb-4">Requests and responses:</h3>
        </div>
        <div className="flex flex-col gap-6">
          {OptionComponent('New Responses to my requests')}
          {OptionComponent("Updates on my responses to other people's requests")}
        </div>
      </div>
    </div>
  );
}

export default NotificationSettings;
